<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xjWrN8/tc-custom/9780544639959.jpg?1728259422519" alt="This image is the cover for the book Where They Lay"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Where They Lay
      </h1>
      <p class="bookDescription body article font2">
        <b>PEN/Martha Albrand Award Finalist: The suspenseful, “poignant” true story of the search for an American military pilot’s remains in Southeast Asia (James Bradley, author of <i>Flags of Our Fathers</i>).</b><br/>  <br/><i>Where They Lay</i> is both an account of an elite military team’s high-tech, high-risk search for a Vietnam War pilot’s remains, and a moving retelling of his intense final hours.<br/>  <br/> In far-flung rain forests and its futuristic lab near Pearl Harbor, the Central Identification Laboratory (CILHI) strives to recover and identify the bodies of fighting men who never came home from America’s wars. Its mission combines old-fashioned bushwhacking and detective work with the latest in forensic technology. Earl Swift accompanies a CILHI team into the Laotian jungle on a search for the remains of Maj. Jack Barker and his three-man crew, whose chopper went down in a fireball more than thirty years ago. He interweaves the story of the recovery team’s work with a tense account of Barker’s fatal attempt to rescue trapped soldiers during the largest helicopter assault in history.<br/>  <br/> The first reporter ever allowed to follow a recovery mission—as these archaeological digs are called—in its entirety, Swift got his hands dirty, combing the jungle floor for clues amid vipers, monsoons, and unexploded bombs. In this “hands-on, thought-provoking” account, he reveals the dedication not only of the fallen servicemen but of the scientists who search for them, and explores questions about the cost of these missions and the corruption among native officials that may compromise them (<i>Minneapolis Star-Tribune</i>).<br/>  <br/> “Informative . . . He interweaves accounts of a generation’s worth of site sifting, involving everything from the most basic shovel work to satellite relaying of computer data, with the whole history of the remains-recovery project . . . He also paints a vivid portrait of deeply impoverished Laos, the sometimes helpful Laotians and the military professionals and technical specialists who make up the search teams.” —<i>Publishers Weekly</i><br/>  <br/> “An unusual tale of war and remembrance.” —<i>Kirkus Reviews</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Earl Swift
      </h2>
      
      <p class="authorDescription body article">Earl Swift is the author of three previous books, including <I>Where They Lay</I>, a 2003 PEN finalist. He lives in Virginia with his daughter Saylor.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?23542c0e